<template>
  <div class="rt">
    <div class="rt-top">
      <div class="main" v-for="(item, index) in cropsData" :key="index">
        <div class="m-item ">
          <p class="title">{{ item.name }}</p>

          <span class="num">{{ item.num1 }}</span>

          <!-- <span class="unit">{{ item.unit }}</span> -->
        </div>
        <div class="line"></div>
        <div class="line2"></div>

      </div>
    </div>
    <div class="rt-bottom" ref="Rtbottom" :style="{ width: '435px', height: '310px' }">

    </div>
  </div>
</template>

<script>
import { data } from 'jquery';

export default {
  name: 'template.rightT-temp3',
  data() {
    return {
      //线路列表
      topMap: [],
      select: {},
      // 已选高速详情列表 name描述 val蓝色字体 unit白色字体
      cropsData: [
        { name: "救援力量", val: "ha", num1: '158', unit: "公顷" },
        { name: "应急物资", val: "kg", num1: '234', unit: "公斤" },
        { name: "避难场所", val: "kind", num1: '24', unit: "种" }
      ],
      numA: [160, 270, 304, 280, 220, 176, 160, 186, 252, 290, 302, 300]
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    TdrawLine() {
      var echarts = require('echarts');
      var TmyChart = echarts.init(this.$refs.Rtbottom);
      let xAxisData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
      var Toption = {
        title: [{
          text: '单位',
          top: '20',
          left: '18',
          textStyle: {
            color: "#B0B5BB",
            fontSize: 12,
          },
        },
        {
          text: '重点人员（老年人、儿童、低保、残疾）病理数据监控',
          top: '20',
          right: '24',
          textStyle: {
            color: "#B0B5BB",
            fontSize: 12,
          },
        },],
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '22%',
          left: '5%',
          right: '8%',

          containLabel: true
        },
        xAxis: {
          // type: 'category',
          boundaryGap: false,
          data: xAxisData,
          axisLabel: {
            margin: 22,
            padding: [0, 20, 0, 20],
            interval: 0,//文字全部显示
            // rotate: 40,
            
            textStyle: {
              color: '#bdc2cb' // 这里将 x 轴文本颜色设为灰白色
            },
          }
        },

        yAxis: {
          // type: 'value',
          min: 0, // 设置y轴刻度的最小值
          // max:400,  // 设置y轴刻度的最大值
          splitNumber: 4,  // 设置y轴刻度间隔个数
          axisLabel: {

            textStyle: {
              color: '#bdc2cb' // 这里将 x 轴文本颜色设为灰白色
            }
          },
          nameTextStyle: {
            padding: [0, 6, 0, 0]

          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: "rgba(231,241,251,.2)"
            }
          }

        },
        series: [
          {
            data: this.numA,
            type: 'line',
            areaStyle: {},
            // smooth: true,//线条原画
            symbol: 'none',//线条点击
            smooth: 0.5,
            lineStyle: {
              color: '#08FAC6',
              width: 2,

            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: "#005449" // 0% 处的颜色 
                }, {
                  offset: 0.3,
                  color: "#006a5b" // 0% 处的颜色
                }, {
                  offset: 1,
                  color: "rgba(0,0,0,.3)" // 100% 处的颜色
                }], false)
              }
            },
          }
        ]
      };
      Toption && TmyChart.setOption(Toption);
      setInterval(function () {
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000)
    },
  },
  mounted() {
    this.$nextTick(() => {
      // this.drawLine(); //需要刷新的数据
      this.TdrawLine(); //需要刷新的数据
    });




  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Benmo-Ziyu";
  src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.rt {
  width: 435px;
  height: 390px;
  display: flex;
  padding: 10px 0;
  position: relative;
}

.rt-top {
  width: 435px;
  height: 82px;
  margin: 14px 0 0 0;
  background: url('../../assets/template3/title-text-bg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  z-index: 1;
}

.main {
  width: 435px;
  display: flex;
  text-align: center;
}

.m-item {
  // flex: 1;
  padding: 12px 0 0 24px;

  .title {
    width: 85px;
    height: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 10px;

  }

  .num {
    width: 36px;
    height: 17px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    // margin: 0 6px 0 4px;
  }

  .unit {
    width: 24px;
    height: 11px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #CBCBCB;
  }
}

.line {
  width: 1px;
  height: 15px;
  background: #125B68;
  position: absolute;
  left: 146px;
  top: 34px;
}

.line2 {
  width: 1px;
  height: 15px;
  background: #125B68;
  position: absolute;
  right: 156px;
  top: 34px;
}

.rt-bottom {
  //减掉96px的高
  // padding: 10px 0;
  margin-top: 106px;
  position: absolute;
  z-index: 5;
  box-sizing: border-box;
}
</style>